
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const PrivacyNotice = () => {
  const { t } = useLanguage();
  
  return (
    <p className="text-xs text-gray-500 dark:text-gray-400 mt-4 text-center">
      <span>{t('contact_basic_privacy')} </span>
      <Link to="/adatkezeles" className="text-primary hover:underline">
        {t('privacy_policy_link')}
      </Link>
    </p>
  );
};

export default PrivacyNotice;
